{
  "PAGINATION_FOOTER": {
    "SHOWING": "Showing {startItem} - {endItem} of {totalItems} items",
    "CURRENT_PAGE_INFO": "{currentPage} of {totalPages} pages"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Select an option...",
    "EMPTY_SEARCH_RESULTS": "No items found for the search term `{searchTerm}`",
    "EMPTY_STATE": "Keine Ergebnisse gefunden.",
    "SEARCH_PLACEHOLDER": "Search...",
    "MORE": "+{count} more"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Search...",
    "EMPTY_STATE": "Keine Ergebnisse gefunden.",
    "SEARCHING": "Suchen..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Stornieren",
      "CONFIRM": "Bestätigen"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Search country",
    "ERROR": "Phone number should be empty or in E.164 format",
    "DIAL_CODE_ERROR": "Bitte wählen Sie die Landesvorwahl aus der Liste"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Autor ist nicht verfügbar"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Breadcrumb"
  },
  "SWITCH": {
    "TOGGLE": "Toggle switch"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Mehr erfahren",
    "WATCH_VIDEO": "Watch video"
  },
  "COLOR_GRID": {
    "SHOW_COLORS": "Farben anzeigen",
    "HIDE_COLORS": "Farben ausblenden"
  },
  "DURATION_INPUT": {
    "MINUTES": "Minuten",
    "HOURS": "Stunden",
    "DAYS": "Tage",
    "PLACEHOLDER": "Dauer eingeben"
  }
}
